import { $ } from './../helpers/query'

export default () => {
  $('.map').each((mapWrapper) => {

    const openMapBtns = $('[data-open-map]', mapWrapper);
    const divider = mapWrapper.querySelector('.map__btn-divider');
    const maps = $('[data-map]', mapWrapper);

    const openOccupiersMapBtns = $('[data-open-occupiers-map]', mapWrapper);
    const occupiersMaps = $('[data-occupiers-map]', mapWrapper);

    openMapBtns.each((btn) => {

      const btnId = btn.getAttribute('data-open-map');
      btn.addEventListener('click', () => {

        openMapBtns.each((btnIn) => {
          const btnInId = btnIn.getAttribute('data-open-map');
          if (btnInId != btnId) {
            btnIn.classList.add('map__btn--inactive')
          } else {
            btnIn.classList.remove('map__btn--inactive')
          }
        })

        if (divider.matches('.map__btn-divider--reflect')) {
          divider.classList.remove('map__btn-divider--reflect')
        } else {
          divider.classList.add('map__btn-divider--reflect')
        }

        maps.each((map) => {
          const mapId = map.getAttribute('data-map');
          if (mapId != btnId) {
            map.style.zIndex = -1;
            map.classList.remove('map__img--active')
          } else {
            map.style.zIndex = 10;
            map.classList.add('map__img--active')
          }
        })

      })

    })

    openOccupiersMapBtns.each((btn) => {

      const id = btn.getAttribute('data-open-occupiers-map');
      btn.addEventListener('click', () => {

        openOccupiersMapBtns.each((btnIn) => {
          console.log(btn != btnIn)
          if (btn != btnIn) {
            btnIn.classList.remove('map__inner-btn--active')
          } else {
            btnIn.classList.add('map__inner-btn--active')
          }
        })

        occupiersMaps.each((map) => {
          const mapId = map.getAttribute('data-occupiers-map');
          if (mapId == id) {
            map.classList.add('map__inner-img--active')
          } else {
            map.classList.remove('map__inner-img--active')
          }
        })

      })

    })

  })
}
